<template>
  <div id="dragable" ref="draggable" class="common-input-title-group" style="width: 100%">

    <div class="common-input-title-group-title-frame">
      <div class="common-input-title-group-title">설문조사</div>
    </div>
    <draggable v-model="list" ghost-class="ghost" @click="onClickDrag($event)" style="width: 100%">
      <transition-group>
        <div v-for="(item, index) in list" v-bind:key="index" class="flex flex-row flex-wrap w-full gap-[5px] lg:gap-[10px] items-center mb-[15px]" @change="onChangeDrag($event)">
          <div class="yn-custom-select-wrapper">
            <div class="yn-custom-select">
              <button type="button" @click="clickFunc(event)">
                <span v-cloak>{{item.code ? item.name : '선택'}}</span>
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 9L12 15L6 9" stroke="#222222" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </button>
              <ul class="list-wrap">
                <li class="flex-shrink-0">
                  <ul>
                    <li v-for="(items, idx) in listCodes">
                      <div>
                        <a @mousedown="fnOnChangeTextAndValue(index, items.code);item.code=items.code">
                          <div>
                            <span v-cloak>{{items.name}}</span>
                          </div>
                        </a>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
<!--
          <select v-model="item.code" @change="fnOnChangeTextAndValue(index, $event.target.value)" style="magrin:0"
                  class="w-full text-[18px] border border-[#222] rounded-[16px] p-3 md:text-[16px] md:py-3 placeholder:text-[18px] placeholder:font-medium placeholder:text-[#999] focus:outline-[#7639DF]"
                  data-gtm-form-interact-field-id="0">

            <option v-for="(items, idx) in listCodes" :value="items.code" v-bind:key="idx">
              {{ items.name }}
            </option>
          </select>-->
          <!--                            <div class="td_input" style="float: left; width:20%;">
                                          <div class="select_form wd_p100">
                                              <label class="select_common">{{item.name}}</label>
                                              <select class="select_custom" v-model="item.code" @change="fnOnChangeTextAndValue(index, $event.target.value)">
                                                  <option v-for="(items, idx) in listCodes" :value="items.code" v-bind:key="idx">{{items.name}}</option>
                                              </select>
                                          </div>
                                      </div>-->

          <input v-model="item.text" type="text"
                 class="common-input-title-group-text flex flex-auto"
          >
          <input v-model="item.value" type="text" :disabled="item.code != 'MEANVSURNV00200'"
                 class="common-input-title-group-text flex flex-auto"
          >
          <!--                            <div style="width: 31%; float:left; margin-top: 10px; font-size: 9px;">
                                          <div style="width: 98%">
                                              <input type="text" class="form_style wd_p100"  v-model="item.text" tabindex="600">
                                          </div>
                                      </div>
                                       <div style="float:left; width:37%; margin-top: 10px; font-size: 9px;">
                                          <div style="width: 98%">
                                             <input type="text" class="form_style wd_p100" v-model="item.value" :disabled="item.code != 'MEANVSURNV00200'" tabindex="600">
                                          </div>
                                      </div>-->

          <div class="flex ml-auto">
            <button class="btn_sm_ghost" @click="fnOnClickRemoveAccodion($event, index);"
                    @keydown.enter="fnOnClickRemoveAccodion($event, index);">삭제
            </button>
          </div>
          <!--                            <div  style="float:left; width:5%; margin-top: 10px;">
                                          <a class="btn_item item_del wd_35 dp_inline cursor" @click="fnOnClickRemoveAccodion($event, index);" tabindex="600" @keydown.enter="fnOnClickRemoveAccodion($event, index);">삭제</a>
                                      </div>-->
        </div>
      </transition-group>
    </draggable>
    <div style="float:right; margin:0 1% 3%" v-if="isExpinfo">
      <!--                 <a class="btn btn_sm btn_orange cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>-->
      <button class="btn_sm_primary" @click="fnOnClickAddAccodion($event, list.length + 1);" tabindex="600"
              @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가
      </button>
    </div>
    <div style="float:right; margin:0 1% 3%" v-if="!isExpinfo">
      <button class="btn_sm_primary" @click="fnOnClickAddAccodion($event, list.length + 1);" tabindex="600"
              @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가
      </button>
      <!--                 <a class="btn btn_sm btn_purple cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>-->
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  data: function () {
    return {
      list: [{name: '5점척도', code: 'MEANVSURNV00100', text: '', value: '매우그렇다|그렇다|보통이다|아니다|매우아니다.', isChecked: false}
        , {name: '자유형객관식', code: 'MEANVSURNV00200', text: '', value: '', isChecked: false}
        , {name: '주관식', code: 'MEANVSURNV00300', text: '', value: '', isChecked: false}],
      changedCodes: [],
      selectCodes: [{name: '5점척도', text: '', code: 'MEANVSURNV00100', values: '매우그렇다|그렇다|보통이다|아니다|매우아니다.'}
        , {name: '자유형객관식', text: '', code: 'MEANVSURNV00200', values: ''}
        , {name: '주관식', text: '', code: 'MEANVSURNV00300', values: ''}],
      selectedSubCode: [],
      labelText: [],
      listCodes: [
        {code: 'MEANVSURNV00100', name: '5점척도', values: '매우그렇다|그렇다|보통이다|아니다|매우아니다.'}
        , {code: 'MEANVSURNV00200', name: '자유형객관식', values: ''}
        , {code: 'MEANVSURNV00300', name: '주관식', values: ''}
      ],

      subList: [],
      surveyList: [],
      clientY: 0,
      classId: null,
      detail: null,
      isExpinfo: false
    }
  }
  , components: {
    draggable
  }
  , props: {
    surveycode: Boolean,
    surveyList: Array
  }
  , create: function () {

  }
  , mounted: function () {
    this.isExpinfo = this.surveycode;
    this.$emit('surveylist', this.list);

  }
  , watch: {
    surveyList: function (newVal, oldVal) {
      let vm = this;
      if (newVal.length > 0) {
        vm.list = [];
        for (let i = 0; i < newVal.length; i++) {
          let _name = "";
          if (newVal.code == "MEANVSURNV00100") {
            _name = "5점척도";
          } else if (newVal == "MEANVSURNV00200") {
            _name = "자유형객관식";
          } else if (newVal == "MEANVSURNV00300") {
            _name = "주관식";
          }

          let tmp = {name: _name, code: newVal.code, text: newVal.text, value: newVal.value, isChecked: false}
          vm.list.push(tmp);
        }
      }
    }
  }
  , beforeDestroy: function () {

  }

  , methods: {
    fnOnClickAddAccodion: function (evt, idx) {
      this.list.push({
        name: '5점척도',
        code: 'MEANVSURNV00100',
        text: '',
        value: '매우그렇다|그렇다|보통이다|아니다|매우아니다.',
        isChecked: false
      });
      this.selectCodes.push({
        id: idx + 1,
        name: '5점척도',
        text: '',
        code: 'MEANVSURNV00100',
        values: '매우그렇다|그렇다|보통이다|아니다|매우아니다.'
      });
      this.$emit('surveylist', this.list);
    }
    , clickFunc: function (event) {
      event.target.focus();// Add me
    },
    fnOnClickRemoveAccodion: function (evt, idx) {
      this.list.splice(idx, 1);
      this.selectCodes.splice(idx, 1);

      // container.scrollTop = container.scrollHeight;
      this.$emit('surveylist', this.list);
    }
    , fnOnChangeSubCodes: function (item, idx) {
      this.changedCodes[idx] = this.selectCodes[idx].code;
      this.subList = this.selectCodes[idx].list;
      this.$emit('surveylist', this.list);

    }
    , onClickDrag: function (evt) {
      this.$emit('surveylist', this.list);
    }
    , onChangeDrag: function (evt) {
      this.$emit('surveylist', this.list);
      console.log("this.list : " + this.list);
    }
    , fnOnChangeTextAndValue(idx, value) {
      let vm = this;
      let content = null;

      if (value == null || value == "") {
        content = vm.selectCodes[0];
      } else {
        content = vm.selectCodes.find(item => item.code == value);
      }

      vm.list[idx].name = content.name;
      vm.list[idx].code = content.code;
      vm.list[idx].text = content.text;
      vm.list[idx].value = content.values;
      vm.$emit('surveylist', vm.list);
    }
    , fnSetSurveyList: function (surveyList) {
      if (this.list.length < surveyList.length) {
        let forLegnth = surveyList.length - this.list.length;
        for (let i = 1; i <= forLegnth; i++) {
          this.fnOnClickAddAccodion(null, surveyList.length - i);
        }
      }
      this.list = surveyList;
      this.$emit('surveylist', this.list);
    }
  }
}
</script>
